"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _default = Object.freeze((0, _keyMirror.default)({
  AUTOMATED_DRAFT: null,
  AUTOMATED_FOR_FORM_BUFFER: null,
  AUTOMATED_FOR_FORM_DRAFT: null,
  BLOG_EMAIL_DRAFT: null,
  DISCARDABLE_STUB: null,
  DRAFT: null,
  DRAFT_AB: null,
  DRAFT_AB_VARIANT: null,
  ERROR: null,
  LOSER_AB_VARIANT: null,
  PAGE_STUB: null,
  RSS_TO_EMAIL_DRAFT: null,
  AUTOMATED: null,
  AUTOMATED_FOR_FORM: null,
  AUTOMATED_SENDING: null,
  BLOG_EMAIL_PUBLISHED: null,
  PRE_PROCESSING: null,
  PROCESSING: null,
  PUBLISHED: null,
  PUBLISHED_AB: null,
  PUBLISHED_AB_VARIANT: null,
  PUBLISHED_NO_CONTACTS: null,
  PUBLISHED_OR_SCHEDULED: null,
  RSS_TO_EMAIL_PUBLISHED: null,
  SCHEDULED: null,
  SCHEDULED_AB: null
}));

exports.default = _default;
module.exports = exports.default;